import * as React from 'react';
import { connect } from 'react-redux';
import * as agui from 'arm-gui/dist/controls';

import ProdottoActions from './prodotto_actions'
import { Utils, domainVal, domain, NumberFormatter, i18n, opt, DateFormatter, isAuth } from 'arm-common';

class Upload extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[Upload.jsx] ";
        this.caricaFile = this.caricaFile.bind(this);
        this.handleFile = this.handleFile.bind(this);
        this.confirmOnClick = this.confirmOnClick.bind(this);
        this.importFileUpload = this.importFileUpload.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.state = {
            file: null,
            filePojo: null,
            docCategory: null,
            ordVis: null,
            operazione: null,
            validation: new Map()
        };
    }

    componentDidMount() {
        this.setState({
            ordVis: this.props.nextOrder,
            file: null,
            filePojo: null,
            docCategory: null,
            operazione: null,
            validation: new Map()
        })
    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.show !== this.props.show && this.props.show) {
            //reset
            this.setState({
                file: null,
                filePojo: null,
                docCategory: null,
                operazione: null,
                validation: new Map()
            })
        }
        if (prevProps && prevProps.nextOrder) {
            //   
        } else {
            if (this.props.nextOrder &&
                this.state.ordVis !== this.props.nextOrder) {
                this.setState({ ordVis: this.props.nextOrder })
            }
        }
    }


    confirmOnClick() {
        console.log(this.componentName + 'confirmOnClick');
        if (!this.validateForm()) {
            return false;
        }
        
        if (this.state.file === null && this.state.docCategory !== 374 && this.state.docCategory !== "374") {
            console.warn("file is NULL")
            return false;
        }

     
        let formData = new FormData();
        if (this.state.docCategory !== 374 && this.state.docCategory !== "374") {
            let file = this.state.file;

            formData.append('file', file);

            if (opt("APP", "FL_FILENAME_REPLACE_SPECIAL_CHARACTERS_REACT", "false") === "true") {
                if (file !== undefined && file !== null) {
                    let nameNoSpecialCharacter = this.replaceSpecialCharacters(file.name);
                    if (nameNoSpecialCharacter !== undefined && nameNoSpecialCharacter !== null && nameNoSpecialCharacter !== "") {
                        formData.append('nameNoSpecialCharacter', nameNoSpecialCharacter);
                    }
                }
            }
        }
        let idProdotto = this.props.idProdotto;
        if (idProdotto !== undefined && idProdotto !== null && idProdotto !== "") {
            formData.append('idProdotto', idProdotto);
        }
        let docCategory = this.state.docCategory;
        if (docCategory !== undefined && docCategory !== null && docCategory !== "") {
            formData.append('docCategory', docCategory);
        }
        let ordVis = this.state.ordVis;
        if (ordVis !== undefined && ordVis !== null && ordVis !== "") {
            formData.append('ordVis', ordVis);
        }

        let operazione = this.state.operazione;
        if (operazione !== undefined && operazione !== null && operazione !== "") {
            formData.append('operazione', operazione);
        }
        this.props.uploadFile(formData).then(
            resolve => {
                this.props.getListaDocumenti();
            }
        )
        this.props.close();
    }

    validateForm() {
        console.log(this.componentName + 'validateForm');
        let validation = new Map();
        let required = ["docCategory", "ordVis"];
        for (let i = 0; i < required.length; i++) {
            if (this.state[required[i]] === undefined || this.state[required[i]] === null || this.state[required[i]] === ''
                || this.state[required[i]].toString().trim() === '') {

                validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
            }
        }

        this.setState({ validation: validation })
        if (validation.size > 0) {
            return false;
        } else {
            return true;
        }
    }

    inputChangeHandler(e) {

        let id = e.target.id;
        let value = e.target.value;
        if (id === "ordVis" && value && value !== "" && value.toString().trim() !== "") {
            value = Number(value);
        }

        if (id === "operazione" && value && value !== "" && value.toString().trim() !== "") {
            value = value;
        }
        let validation = this.state.validation;
        if (validation.has(id)) {
            validation.delete(id);
        }
        let object = this.state;
        object[id] = value;
        this.setState(object);
    }


    handleFile(event) {
        event.preventDefault();
        let e = event.dataTransfer === undefined ? event.target : event.dataTransfer || null;
        if (!e) {
            console.warn(this.componentName + "no event for drop file");
            return;
        }

        console.log(this.componentName + " handleFile " + e.files[0].name, e);
        let file = e.files[0];

        this.setState({ file: file });
    }

    caricaFile(event) {
        let e = event.dataTransfer === undefined ? event.target : event.dataTransfer;
        console.log(this.componentName + " caricaFile " + e.files[0].name, e);

        let filePojo = new Object();
        let that = this;

        let reader = new FileReader();
        reader.readAsDataURL(e.files[0]);
        reader.onload = function (e) {

            console.warn("file data: " + e.target.result);
        }

        this.setState({ filePojo: filePojo });
    }

    importFileUpload(filePojo) {
        console.log(this.componentName + 'importFileUpload');
        let self = this;
        if (filePojo === undefined || filePojo !== null) {
            return Promise.resolve({ ok: false });
        }


        return this.props.uploadFile(filePojo).then(
            resolve => {

            }
        );


    }

    replaceSpecialCharacters(fileName) {
        if (fileName !== null && fileName !== undefined) {
            fileName = fileName.replace("à", "a");
            fileName = fileName.replace("è", "e");
            fileName = fileName.replace("ì", "i");
            fileName = fileName.replace("ò", "o");
            fileName = fileName.replace("ù", "u");
            fileName = fileName.replace("À", "A");
            fileName = fileName.replace("È", "E");
            fileName = fileName.replace("Ì", "I");
            fileName = fileName.replace("Ò", "O");
            fileName = fileName.replace("Ù", "U");
            fileName = fileName.replace("á", "a");
            fileName = fileName.replace("é", "e");
            fileName = fileName.replace("í", "i");
            fileName = fileName.replace("ó", "o");
            fileName = fileName.replace("ú", "u");
            fileName = fileName.replace("Á", "A");
            fileName = fileName.replace("É", "E");
            fileName = fileName.replace("Í", "I");
            fileName = fileName.replace("Ó", "O");
            fileName = fileName.replace("Ú", "U");
            fileName = fileName.replace("ý", "y");
        }
        return fileName;
    }

    render() {
        console.log(this.componentName + 'render [show]' + this.props.show);
        return (

            <agui.ConfirmModalOkCancelV4 show={this.props.show} >
                <agui.ConfirmModalOkCancelV4.Header testoTitle="Upload" onClose={this.props.close} />
                <agui.ConfirmModalOkCancelV4.Body  testoBody="">

                    <div className="row mt-1">

                        <div className="col col-sm-12 col-md-12 col-lg-12">
                            <agui.ASelectV4
                                id="docCategory"
                                required
                                onChange={this.inputChangeHandler}
                                value={this.state.docCategory}
                                validation={this.state.validation}
                                label={i18n('ARM_CORE_PRODUCT.SHARED.CAT_DOCUMENT', 'Categoria Documento')}
                                items={domain("AI_DOCUMENT_CATEGORY")}
                                valueKey="valCampo"
                                labelKey="desDom"
                            />
                        </div>
                    </div>
                    <div className="row mt-1">
                        <div className="col col-sm-12 col-md-12 col-lg-12">
                            <agui.ASelectV4
                                id="ordVis"
                                required
                                onChange={this.inputChangeHandler}
                                value={this.state.ordVis}
                                label={i18n('ARM_CORE_PRODUCT.SHARED.ORDINE_VIS', 'Ordine visibilità')}
                                items={this.props.ordersList}
                                valueKey="value"
                                labelKey="value"
                                validation={this.state.validation}
                            />
                        </div>
                    </div>
                    {isAuth('V2.ADMIN.PRODUCT.TAB_DOC_OUT.VIEW.TIPO_OPERAZIONE') &&
                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ASelectV4
                                    id="operazione"
                                    onChange={this.inputChangeHandler}
                                    value={this.state.operazione}
                                    label={i18n('ARM_CORE_PRODUCT.PRODOTTO.DOCUMENTO.TIPO_OPERAZIONE', 'Tipo operazione')}
                                    items={this.props.tipoOperazioneList}
                                    valueKey="valCampo"
                                    labelKey="desDom"
                                    validation={this.state.validation}
                                />
                            </div>
                        </div>
                    }
                    {this.state.docCategory === 374 || this.state.docCategory === "374" ?
                        null
                        :
                        <div className="row mt-1 mb-3 ml-3">

                            <input name="file" type="file" onChange={(e) => this.handleFile(e)} />

                        </div>}
                        
                    <agui.ConfirmModalOkCancelV4.Body testoBody={(this.props.testoBody !== undefined && this.props.testoBody !== null) ?
                        this.props.testoBody : i18n('ARM_CORE_PRODUCT.CONFERMI_DI_VOLER', 'Confermi di voler procedere?')} />


                    {/* </div> */}

                </agui.ConfirmModalOkCancelV4.Body >
                <agui.ConfirmModalOkCancelV4.Footer
                    testoButtonConfirm="Upload"
                    testoButtonCancel = {i18n('ARM_CORE_PRODUCT.SHARED.ANNULLA', 'Annulla')}
                    confirmOnClick={this.confirmOnClick}
                    onClose={this.props.close}>
                </agui.ConfirmModalOkCancelV4.Footer>
            </agui.ConfirmModalOkCancelV4 >
        );
    }
}


function mapDispatchToProps(dispatch) {
    return {
        uploadFile: function (formData) {
            return dispatch(ProdottoActions.uploadFile(formData));
        },
        getListaDocumenti: function () {
            return dispatch(ProdottoActions.getListaDocumenti());
        },

    }
};
export default connect(null, mapDispatchToProps)(Upload);
